import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=1a186436&scoped=true&"
import script from "./CardDetail.vue?vue&type=script&lang=js&"
export * from "./CardDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardDetail.vue?vue&type=style&index=0&id=1a186436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a186436",
  null
  
)

export default component.exports